// Club subdomains: `{slug}.unionclubs.com`.
// Keep RESERVED_SLUGS in sync with app.is_reserved_slug(), last defined in
// supabase/migrations/20261019000200_reserve_staff_slug.sql. A test in apps/api
// compares the two, so drift fails CI.

export const RESERVED_SLUGS = [
  "www",
  "api",
  "admin",
  "console",
  "staff",
  "auth",
  "app",
  "apps",
  "mail",
  "email",
  "status",
  "help",
  "support",
  "docs",
  "dev",
  "staging",
  "preview",
  "test",
  "demo",
  "cdn",
  "static",
  "assets",
  "media",
  "blog",
  "about",
  "pricing",
  "login",
  "signin",
  "signup",
  "account",
  "accounts",
  "billing",
  "security",
  "union",
  "unionclubs",
  "internal",
  "ops",
] as const;

const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;

export function isValidClubSlug(slug: string): boolean {
  return SLUG_PATTERN.test(slug) && !(RESERVED_SLUGS as readonly string[]).includes(slug);
}

/** `pinevalley.unionclubs.com` → `pinevalley`; anything else → null. */
export function clubSlugFromHost(host: string, rootDomain: string): string | null {
  const hostname = host.split(":")[0]?.toLowerCase() ?? "";
  const suffix = `.${rootDomain}`;
  if (!hostname.endsWith(suffix)) return null;
  const slug = hostname.slice(0, -suffix.length);
  return isValidClubSlug(slug) ? slug : null;
}
